import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/common/ScrollToTop";
import Home from "./pages/Home";
import Works from "./pages/Works";
import NotFound from "./pages/NotFound";
import ProjectDetail from "./components/projects/ProjectDetail";
import { useScrollReveal } from "./hooks";
import "./styles/base.css";

/**
 * Application shell: router, persistent chrome, and the global scroll-reveal
 * observer.
 *
 * Route notes — the Bosnian paths are canonical, with the previous English
 * ones kept as redirects so links already in circulation do not break:
 *
 *   /                      home
 *   /projekti              archive       (old: /projects)
 *   /project/:projectId    detail page; accepts a slug or the old numeric id
 *
 * @returns {JSX.Element}
 */
function App() {
  useScrollReveal();

  return (
    <Router>
      <ScrollToTop />

      <a className="skip-link" href="#main">
        Preskoči na sadržaj
      </a>

      <Header />

      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/projekti" element={<Works />} />
          {/* Retired English path, kept so existing links keep resolving */}
          <Route path="/projects" element={<Navigate to="/projekti" replace />} />

          <Route path="/project/:projectId" element={<ProjectDetail />} />
          <Route path="/projekat/:projectId" element={<ProjectDetail />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
    </Router>
  );
}

export default App;
